import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Report } from "../../types/Report";
import { Typography } from "@mui/material";
import axios from "axios";

interface ReportDeleteDialogProps {
  open: boolean;
  report: Report;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setReports: React.Dispatch<React.SetStateAction<Report[] | undefined>>;
}

export default function ReportDeleteDialog({
  open,
  report,
  setOpen,
  setReports,
}: ReportDeleteDialogProps) {
  const handleClose = () => {
    setOpen(false);
  };

  const deleteReport = () => {
    axios
      .post(`${process.env.REACT_APP_API_HOST}/report/delete`, {
        reportId: report._id,
      })
      .then(() => {
        setReports((prev) => prev?.filter((r) => r._id !== report._id));
        handleClose();
      });
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Eliminar reporte - {report.reportPeriod}</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro que deseas eliminar este reporte?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={deleteReport} variant="contained" color="error">
            Eliminar
          </Button>
          <Button onClick={handleClose} variant="outlined">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
